var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedinCircled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.1279H28C29.1046 10.1279 30 11.0234 30 12.1279V28.1279C30 29.2325 29.1046 30.1279 28 30.1279H12C10.8954 30.1279 10 29.2325 10 28.1279V12.1279C10 11.0234 10.8954 10.1279 12 10.1279ZM12 12.1279V28.1279H28V12.1279H12ZM21 17.1279C20.4823 17.1279 19.9353 17.2862 19.4521 17.5801L19 17.1279H18V24.1279H20V20.1279C20 19.5522 20.594 19.1279 21 19.1279H22C22.406 19.1279 23 19.5522 23 20.1279V24.1279H25V20.1279C25 18.2751 23.394 17.1279 22 17.1279H21ZM16 16.1279C16.5523 16.1279 17 15.6802 17 15.1279C17 14.5756 16.5523 14.1279 16 14.1279C15.4477 14.1279 15 14.5756 15 15.1279C15 15.6802 15.4477 16.1279 16 16.1279ZM15 17.1279V24.1279H17V17.1279H15Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.62793,
    width: 39,
    height: 39,
    rx: 19.5,
    stroke: "#3A3A3A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinCircled);
export default __webpack_public_path__ + "static/media/linkedin-circled.e4e4fa19c7b4c21b3a01a636849ba303.svg";
export { ForwardRef as ReactComponent };